import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import CKEditor from './Example';
import _ from 'lodash';
import insertModeloNota2 from '../../graphql/mutations/editor/insertModeloNota2';
import { errorService } from '../../graphql/utils/utils';

/*

    CLASE ENCARGADA DE REALIZAR TODAS LAS OPERACIONES NECESARIAS EN LA CREACION DE UN MODELO NOTA.
    LLAMA AL EDITOR PARA PODER OPERAR.

*/

class CrearContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modelo_nota: {
        titulo: '',
        descripcion: '',
        htmlModelo: '',
        categorias: [],
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onSubmit(modelo_nota) {
    this.setState({ modelo_nota });

    let nuevosParesTalonarios = [];
    let organismos = [];

    _.map(modelo_nota.talonarios, par => {
      organismos.push(par.organismo._id);
      nuevosParesTalonarios.push({
        idTalonario: par.talonario._id,
        idOrganismo: par.organismo._id,
      });
    });

    this.setState({
      loading: true,
    });

    this.props
      .mutate({
        variables: {
          titulo: modelo_nota.titulo,
          descripcion: modelo_nota.descripcion,
          htmlModeloNota: modelo_nota.htmlModelo,
          categorias: modelo_nota.categorias,
          talonarios: nuevosParesTalonarios,
          organismos: organismos,
          clasificadoresEstadisticos: modelo_nota.clasificadoresEstadisticos,
        },
      })
      .then(res => {
        // eslint-disable-next-line no-unused-vars
        let idModeloNota = res.data.insertModeloNota._id;
        this.setState({
          loading: false,
        });
        this.props.history.push('listar');
      })
      .catch(error => {
        console.log('Error a la hora de crear el modelo');
        console.log(error);
        errorService(error, {
          titulo: modelo_nota.titulo,
          descripcion: modelo_nota.descripcion,
          htmlModeloNota: modelo_nota.htmlModelo,
          categorias: modelo_nota.categorias,
          talonarios: nuevosParesTalonarios,
          organismos: organismos,
          clasificadoresEstadisticos: modelo_nota.clasificadoresEstadisticos,
        });
        this.setState({
          loading: false,
        });
      });
  }

  onCancel() {
    //TODO: Agregar un SweetAlert o similar para preguntar si desea volver sin guardar.
    this.props.history.goBack();
  }

  onChange() {}

  onDelete() {}

  render() {
    const { modelo_nota } = this.state;

    return (
      <div>
        <CKEditor
          modelo_nota={modelo_nota}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onChange={this.onChange}
          onDelete={this.onDelete}
          accion="crear"
          loading={this.state.loading}
        />
      </div>
    );
  }
}

export default graphql(insertModeloNota2)(CrearContainer);
